import { render, staticRenderFns } from "./DivisionBetToggle.vue?vue&type=template&id=15cafc42&scoped=true&"
import script from "./DivisionBetToggle.vue?vue&type=script&lang=js&"
export * from "./DivisionBetToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cafc42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
